import { ModalsProvider } from "@mantine/modals";

export function BaseLayout({ children }: { children: React.ReactNode }) {
  return <ModalsProvider>{children}</ModalsProvider>;
}
